import request from "_private/utils/request";

/**
 * @description  仓库信息列表接口
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
export function findByPage(data) {
  return request({
    url: "/examine/storageInfo/findByPage",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * @description  仓库信息核查接口
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
export function findStorageInfoById(data) {
  return request({
    url: "/examine/storageInfo/findStorageInfoById",
    method: "post",
    // headers: { type: "json" },
    data
  });
}

/**
 * @description  仓库信息核查通过接口
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
export function verifyStorageInfo(data) {
  return request({
    url: "/examine/storageInfo/verifyStorageInfo",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * @description  仓库信息下拉
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
export function findAllStorages() {
  return request({
    url: "/examine/storageInfo/findAllStorages",
    method: "post"
  });
}

/**
 * @description  Urgent仓库信息下拉
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
export function findAllUrgentStorages() {
    return request({
        url: "/ug/storage/findAllUrgentStorages",
        method: "post"
    });
}
